import { render, staticRenderFns } from "./Solution1.vue?vue&type=template&id=2b1ddd02&scoped=true"
import script from "./Solution1.vue?vue&type=script&lang=js"
export * from "./Solution1.vue?vue&type=script&lang=js"
import style0 from "./Solution1.vue?vue&type=style&index=0&id=2b1ddd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ddd02",
  null
  
)

export default component.exports